import React, {
  useEffect,
  useState,
} from "react";

import axios from "axios";
import { API_BASE } from "../../../config";

import { motion } from "framer-motion";

import AdminTicketList from "./AdminTicketList";
import AdminTicketThread from "./AdminTicketThread";

const AdminSupport = () => {

  const [tickets, setTickets] =
    useState([]);

  const [selectedTicket,
    setSelectedTicket] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  const admin =
    JSON.parse(localStorage.getItem("user"));

  const token = admin?.token;

  // ====================================
  // FETCH ALL TICKETS
  // ====================================
  const fetchTickets = async () => {

    try {
      const res = await axios.get(
`${API_BASE}/api/admin/feedback/tickets`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const ticketData =

Array.isArray(
res.data?.tickets
)

?

res.data.tickets

:

Array.isArray(
res.data
)

?

res.data

:

[];

setTickets(
ticketData
);

if (

ticketData.length > 0 &&

!selectedTicket

){

setSelectedTicket(
ticketData[0]
);

} {
        setSelectedTicket(
          res.data.tickets[0]
        );
      }

    } catch (error) {
      console.error(
        "Admin Fetch Tickets Error:",
        error
      );
    } finally {
      setLoading(false);
    }
  };

  // ====================================
  // INITIAL FETCH
  // ====================================
  useEffect(() => {
    fetchTickets();
  }, []);

  // ====================================
  // POLLING
  // ====================================
  useEffect(() => {

    const interval =
      setInterval(() => {
        fetchTickets();
      }, 30000);

    return () =>
      clearInterval(interval);

  }, []);

  return (
    <div className="w-full h-[calc(100vh-80px)] p-4">

      <motion.div
        initial={{
          opacity: 0,
          y: 10,
        }}
        animate={{
          opacity: 1,
          y: 0,
        }}
        className="
          w-full
          h-full
          rounded-3xl
          overflow-hidden
          border
          border-gray-200
          dark:border-gray-700
          bg-white
          dark:bg-gray-900
          shadow-2xl
          flex
        "
      >

        {/* LEFT PANEL */}
        <div
          className="
            w-[380px]
            border-r
            border-gray-200
            dark:border-gray-700
            flex
            flex-col
          "
        >

          {/* HEADER */}
          <div
            className="
              p-5
              border-b
              border-gray-200
              dark:border-gray-700
            "
          >
            <h2
              className="
                text-2xl
                font-bold
                text-gray-800
                dark:text-white
              "
            >
              Support Inbox
            </h2>

            <p
              className="
                text-sm
                text-gray-500
                mt-1
              "
            >
              Manage user conversations
            </p>
          </div>

          {/* TICKET LIST */}
          <div className="flex-1 overflow-y-auto">

            <AdminTicketList
              tickets={tickets}
              loading={loading}
              selectedTicket={
                selectedTicket
              }
              setSelectedTicket={
                setSelectedTicket
              }
            />

          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="flex-1">

          <AdminTicketThread
            selectedTicket={
              selectedTicket
            }
            refreshTickets={
              fetchTickets
            }
          />

        </div>
      </motion.div>
    </div>
  );
};

export default AdminSupport;